import { createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/salvou_logo.svg'


const _withScopeId = n => (_pushScopeId("data-v-5c833af0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "Opa! Salvou Logo",
  src: _imports_0,
  class: "logo"
}, null, -1 /* HOISTED */))
const _hoisted_2 = { class: "buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("header", {
    class: "container",
    style: _normalizeStyle({
    boxShadow: $setup.scrollTop > 0 ? '0px 4px 4px rgba(0, 0, 0, 0.1)' : 'none',
  })
  }, [
    _createVNode($setup["CartModal"], { ref: "cartModal" }, null, 512 /* NEED_PATCH */),
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode(" <CommonButton type=\"text\">Ofertas</CommonButton>\r\n      <CommonButton type=\"text\">Contato</CommonButton> "),
      _createVNode($setup["CartButton"], {
        onOpenCartModal: _cache[0] || (_cache[0] = ($event: any) => ($setup.cartModal?.open()))
      })
    ])
  ], 4 /* STYLE */))
}